import RegimeChart from './RegimeChart';

export default RegimeChart;
